import React from 'react';
import PropTypes from 'prop-types';
import PipeString from 'flaivy-react/components/inputs/PipeString';
import _ from 'lodash';

class PipeStringFilter extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      // eslint-disable-next-line
      value: PropTypes.object,
    };
  }

  static get defaultProps() {
    return {
      value: {},
    };
  }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key, newValue) {
    const { onChange, name } = this.props;
    if (!newValue || newValue === '<NULL>') {
      onChange(name, { iLike: '%' });
      return;
    }
    onChange(name, { iLike: `${newValue}%` });
  }

  render() {
    const { props } = this;
    const { name } = props;
    const value = _.get(props, 'value.iLike', '').replace('%', '');
    return (
      <PipeString name={name} value={value} onChange={this.handleChange} />
    );
  }
}

export default PipeStringFilter;
